import React, { Component } from 'react';
import authService from './api-authorization/AuthorizeService'
import ReactCardFlip from 'react-card-flip';

export class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    this._subscription = authService.subscribe(() => this.populateState());
    this.populateState();
  }

  componentWillUnmount() {
    authService.unsubscribe(this._subscription);
  }

  async populateState() {
    const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
    this.setState(prevState => ({
      ...prevState,
      isAuthenticated,
      isFlipped: false,
      fliptext1: this.getText(1),
      fliptext2: '',
      selectedindex: 1,
      userName: user && user.name
    }));
  }

  getText(index) {
    switch (index) {
      case 1: return 'Скрупулезно выбирайте идеальный номер в отеле из тысяч вариантов. Бронируйте столик в ресторане. Берите в аренду всё для воплощения идей — от дизайнерского платья и мощного внедорожника до профессиональной камеры, строительного инструмента или даже яхты. Легко записывайтесь к парикмахеру, врачу, на сервис автомобиля или пробное занятие в студию.';
      case 2: return 'Перед тем как записаться вы видите не просто свободные «окна» для записи, а наглядную загрузку выбранного сервиса в разные дни. Хотите тихого визита? Выберите наименее загруженный день. Планы гибкие? Система подскажет, когда спрос и цены ниже. А если интересующая вас дата становится популярной, вы получите уведомление, чтобы успеть забронировать место первым.';
      case 3: return 'Мечтали о теннисном матче, сеансе в спа-четвером или мастер-классе в паре, но не с кем пойти? Если услуга требует двух участников, а у вас нет подходящего партнёра, просто отметьте это — и наша система поможет его найти. Бронирование автоматически подтвердится, как только пара будет собрана, открывая вам двери к новым знакомствам и впечатлениям.';
      case 4: return 'Забудьте о сюрпризах при оплате. Вы всегда видите точную, финальную цену на услугу или аренду заранее, включая все налоги и сборы. Никаких скрытых затрат — только честная сделка. Мы не берем никаких комиссий с поставщика услуг.';
      case 5: return 'Все ваши бронирования, записи и аренда мгновенно синхронизируются в ваш единый календарь. Вы всегда видите полную картину своего времени — от путешествий и ужинов до деловых встреч и сроков аренды оборудования.';
    }
  }

  handleClick(e, index) {
    e.preventDefault();
    this.setState(prevState => ({ isFlipped: !prevState.isFlipped, fliptext1: prevState.isFlipped?this.getText(index):prevState.fliptext1, fliptext2: prevState.isFlipped?prevState.fliptext2:this.getText(index), selectedindex: index }));
  }

  render () {
    return (
      <div class="main">
        <div class="main1">
        <div class="intro"></div>
        <div class="main2 w50">Добро пожаловать в сервис, где вы управляете своим временем, а не оно вами.</div>
        <div style={{display: "none"}}>Позвольте себе жизнь без ожиданий и неожиданностей.</div>
        <div class="main3 w50">Представьте мир, где вы не просто планируете, а принимаете взвешенные решения о своём времени. Наша платформа — это ваш персональный портал в мир без суеты, где даже самые сложные планы становятся простыми.</div>
        <div class="main3 w50">Вы — автор своего расписания. И мы даём вам для этого все возможности:</div>
        <div class="main3 w50">
        <ReactCardFlip isFlipped={this.state.isFlipped} flipDirection="horizontal">
          <div class="h50">{this.state.fliptext1}</div>
          <div class="h50">{this.state.fliptext2}</div>
        </ReactCardFlip>
        </div>
        <ul class="main3 w50">
          <li class={this.state.selectedindex==1?'selectedli':''}><a onClick={(e)=>this.handleClick(e, 1)} href='#'>Мир возможностей в одном месте</a> </li>
          <li class={this.state.selectedindex==2?'selectedli':''}><a onClick={(e)=>this.handleClick(e, 2)} href='#'>Осознанный выбор</a></li>
          <li class={this.state.selectedindex==3?'selectedli':''}><a onClick={(e)=>this.handleClick(e, 3)} href='#'>Партнер для любых начинаний</a></li>
          <li class={this.state.selectedindex==4?'selectedli':''}><a onClick={(e)=>this.handleClick(e, 4)} href='#'>Прозрачность и уверенность</a></li>
          <li class={this.state.selectedindex==5?'selectedli':''}><a onClick={(e)=>this.handleClick(e, 5)} href='#'>Всё под вашим контролем на одной странице</a></li>
        </ul>
        <div class="main4 w50">Ваше время бесценно. Тратьте его на жизнь, а не на планирование.</div>
        <div class="main3 w50">{!this.state.isAuthenticated?<a style={{marginBottom: "5px"}} class="btn btn-primary" href="authentication/register">Зарегистрироваться</a>:<></>} <a style={{marginBottom: "5px"}} class="btn btn-primary" href="booking">Начать бронирование</a></div>
        <p></p>
        </div>

        <div class="main0">
        <div class="w60"><div class="main2">У вас свой бизнес и вы еще не с нами?</div>
          <div class="main3">Откройте мир, где ваши услуги находят клиентов, а администрация работает на автопилоте. Бесплатно — навсегда.
          Представьте платформу, которая становится вашим полноправным партнером в развитии. Она не просто приводит клиентов — она создает комфортный метод взаимодействия, который ценит и ваш бизнес, и ваши сотрудники. И мы не берем за это ни копейки: никаких абонентских плат, скрытых комиссий или процентов за бронирование. Вы платите только стандартную комиссию банка за эквайринг — как при любой обычной онлайн-оплате или смс-информирование при необходимости.</div>
          <div class="main2 orange">Привлекайте целевых клиентов там, где они планируют свою жизнь:</div>
          <ul class="main3">
            <li>Ваш отель, ресторан или салон красоты становится частью их планов, когда они выбирают из тысяч вариантов.</li>
            <li>Ваши товары для аренды — от дизайнерской одежды и профессиональных инструментов до строительного оборудования — находят своего идеального временного владельца.</li>
          </ul>
          <div class="main2 w40">Ваш бизнес заслуживает безупречной организации.</div>
          <div class="main3 w40">Мы берем на себя управление временем, чтобы вы могли сосредоточиться на качестве услуг. Начните расти без лишних затрат.</div>
          <div class="main2 orange">Забудьте о «двойных бронированиях» и путанице.</div>
          <div class="main3">Наше ключевое преимущество — единое пространство времени. Календарь вашего сотрудника на работе интегрируется с его личным календарем как клиента. Если парикмахер записался к стоматологу, его рабочее расписание автоматически обновится, исключив это время для записи клиентов. Это предотвращает конфликты, снижает стресс и создает прозрачность для всей команды.</div>
        </div>
        <div class="w40">
          <div class="main2 orange">Что это дает вам?</div>
          <ul class="main3">
            <li>Интеллектуальное расписание учитывает личные планы команды.</li>
            <li>Снижение административной нагрузки. Больше не нужно вручную сверять расписания и согласовывать переносы.</li>
            <li>Ваши сотрудники ценят вас. Вы даете им удобный инструмент для управления их собственным временем — и рабочим, и личным.</li>
            <li>Все бронирования в одном месте, даже если к вам записываются старым способом, на экране вашего смартфона компьютера или планшета в офисе и смартфонах каждого из ваших сотрудников (собственное расписание с возможностью записи).</li>
            <li>Полная история ваших ресурсов, будь то строительное оборудование, автомобили или сотрудник в одном месте.</li>
            <li>Вы всегда на связи с клиентом. Они видят ваше реальное, актуальное расписание и бронируют услуги 24/7, а вы получаете гарантированно свободный ресурс.</li>
            <li>Единый рейтинг добросовенности клиентов между различными компаниями</li>
            <li>Различные отчеты о загрузке сотрудников, рабочих мест, ежедневные, филиалов</li>
            <li>Гибкие настройки услуг с ценами и возможными дополнительными опциями для каждой услуги</li>
            <li>Собственная страница компании с возможностью бронирования клиентами абсолютно бесплатно, генерация ссылки в виде QR-кода для вывешивания на стенд</li>
            <li>Прозрачные условия. Вы всегда знаете, сколько заплатите за эквайринг и смс-информирование, если подключено, все остальное бесплатно и никаких неожиданностей.</li>
          </ul>
        </div>
        </div>
        <div class="main4 w40">Станьте частью экосистемы, где технологии работают на гармонию вашего бизнеса и жизни вашей команды. Бесплатно навсегда.</div>
        <p></p>
        <p class="main3">{!this.state.isAuthenticated?<a style={{marginBottom: "5px"}} class="btn btn-primary" href="authentication/register">Зарегистрироваться</a>:<></>} <a style={{marginBottom: "5px"}} class="btn btn-primary" href="configcompany">Зарегистрировать бизнес бесплатно</a></p>
        <p></p>
      </div>
    );
  }
}
